import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'qumra-checkbox-input',
  styleUrl: 'qumra-checkbox-input.css',
  shadow: true,
})
export class QumraCheckboxInput {
  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
